<template>
  <v-dialog v-model="flagging" width="400">
    <v-tooltip bottom slot="activator">
      <slot name="activator" slot="activator" @click.stop="flagging = true">
        <v-btn flat>
          <span>Flag</span>
        </v-btn>
      </slot>
      <span>Click to flag</span>
    </v-tooltip>
    <v-card>
      <v-card-title :class="themes.client.light.dialogTitle">
        <div>
          <span class="subheading" v-if="profile">
            Flag {{ profile.firstName }} {{ profile.lastName }}
          </span>
          <div v-if="target && target.type">
            Please provide a reason for flagging this {{ target.type.replace( /([A-Z])/g, " $1" ).toLowerCase() }}
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-radio-group v-model="key">
          <v-radio
            v-for="flag in filteredFlags"
            :key="flag.key"
            :label="flag.name"
            :value="flag.key"
            :color="themes.client.light.input"
          ></v-radio>
        </v-radio-group>

        <p v-if="flag && flag.description">
          Submitting this flag will {{ flag.description.toLowerCase() }}
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn flat @click.stop="flagging = false">Cancel</v-btn>
        <v-btn
          :color="themes.client.light.primaryActionButton"
          @click.stop="submit"
          :disabled="!key"
          :loading="loading"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Data
import flags from '@/data/flags'

// Helpers
import _ from 'lodash'

export default {
  props: {
    filter: { type: Array },
    profile: { type: Object, required: true },
    target: { type: Object, required: true },
  },

  data() {
    return {
      flagging: false,
      loading: false,
      key: null,
      flags,
    }
  },

  computed: {
    flag() {
      if (!this.key) return

      return this.flags.find(f => f.key === this.key)
    },

    filteredFlags() {
      if (!_.get(this, 'flags[0]')) return []
      if (!_.get(this, 'filter[0]')) return this.flags

      return this.flags.filter(f => this.filter.indexOf(f.key.split('.')[0]) >= 0)
    },
  },

  methods: {
    submit() {
      if (!this.profile.id) return
      if (!this.target.id || !this.target.type) return

      this.loading = true
      this.$store
        .dispatch('client/flags/create', {
          profile: this.profile,
          target: this.target,
          key: this.key,
        })
        .then(
          response => {
            this.flagging = false
            this.$emit('done')
            this.$store.dispatch('snackbarSuccess', 'Reported')
          },
          errors => {
            this.$store.dispatch('snackbarError', 'Failed to Submit')
          }
        )
        .finally(() => (this.loading = false))
    },
  },
}
</script>
